import { render } from "./THOCView.vue?vue&type=template&id=2bf313c3"
import script from "./THOCView.vue?vue&type=script&lang=js"
export * from "./THOCView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__